import React, {Component} from 'react';
import {Tooltip} from "antd";
import interviewIcon from "../../sysManagement/selectedTopicManagement/columnRender/interviewIcon.png";

class NormalTitle extends Component {
    static defaultProps = {
        width:340,
        dataIndex: "title"
    };
    render() {
        let {record, width, dataIndex} = this.props;
        let data = "";
        try {
            eval(`data = record.${dataIndex}`);//这里是为了避免dataIndex 为 属性中的属性，所以不能单纯的使用 record[dataIndex]
        }catch (e) {

        }

        return (<div style={{width:width-20,overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap"}}>
            <Tooltip  placement="topLeft" title={data}>{data}</Tooltip>
        </div>
        )

    }
}

export default NormalTitle;
